import { createModalHook } from '../../hooks/useModal'

export const useEditPasswordModal = createModalHook()
